window.$ = window.jQuery = require('jquery');
import { Swiper } from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import fullpage from 'fullpage.js/dist/fullpage.min';
import 'fullpage.js/dist/fullpage.min.css';

require('./web_function')

$(function () {

    $('.rd-go-url').on('click', function () {
        window.location.href = $(this).data('url')
    })
    newsSwiper()
    $('.rd-change-news-category').on('click', function () {
        let url = $('meta[name="load-news"]').attr('content')
        let id  = $(this).data('id')
        $('#rd-load-news').load(url, {news_category_id: id}, function () {
            newsSwiper()
        })

        $('.rd-change-news-category').removeClass('now').eq($(this).index()).addClass('now')
    })

    $('.body_mouth').hover(function() {
        $(this).parent('.body_box').find('.mouth').find(".hidden_of_body").toggleClass("now");
    });
    $('.body_lungs').hover(function() {
        $(this).parent('.body_box').find('.lungs').find(".hidden_of_body").toggleClass("now");
    });

    new fullpage('#rd-fullpage', {
        licenseKey: '64CMK-AL9IK-BW8KK-YEJTJ-WKEHL',
        autoScrolling: true,
        fitToSection: true,
        scrollingSpeed:600,
        easing: 'easeInOutCubic',
        easingcss3: 'ease',
        scrollOverflow: false,
        lockAnchors: false,
        navigation: false,
        navigationPosition: 'right',
        navigationTooltips: ['firstSlide', 'secondSlide'],
        showActiveTooltip: false,
        slidesNavigation: false,
        slidesNavPosition: 'bottom',
        scrollBar: false,
        touchSensitivity: 15,
        normalScrollElementTouchThreshold: 5,
        onLeave: function(index, newIndex, direction){
            switch (newIndex.index) {
                case 0:
                    $('.index_banner').addClass('move')
                    if($(window).width()>768)
                    {
                        switchHeaderBlue(true)
                    }
                    break;
                case 1:
                    $('.index_choose').addClass('move')
                    if($(window).width()>768)
                    {
                        switchHeaderBlue(true)
                    }
                    break;
                case 2:
                    $('.index_advantage').addClass('move')
                    if($(window).width()>768)
                    {
                        switchHeaderBlue(true)
                    }
                    break;
                case 3:
                    $('.index_breathe').addClass('move')
                    if($(window).width()>768)
                    {
                        switchHeaderBlue(false)
                    }
                    break;
                case 4:
                    $('.index_fog').addClass('move')
                    if($(window).width()>768)
                    {
                        switchHeaderBlue(false)
                    }
                    break;
                case 5:
                    $('.index_news').addClass('move')
                    if($(window).width()>768)
                    {
                        switchHeaderBlue(true)
                    }
                    break;
                default:
            }
        },
        afterRender: function(origin, destination, direction, trigger){
            $('.index_hcmed').addClass('move')
            switchHeaderBlue(false)
        },
        afterResize: function(width, height){
        },
    });


    const stars = document.querySelectorAll('.star');

    stars.forEach((star, index) => {
        const top = getRandom(0, 100) + 'vh';
        const left = getRandom(0, 100) + 'vw';
        const delay = getRandom(0, 15) + 's';

        star.style.top = top;
        star.style.left = left;
        star.style.animationDelay = delay;
    });


    $(window).resize(function () {
        if($(this).width()>768){
            fullpage_api.setAutoScrolling(true);
            fullpage_api.setFitToSection(true);
        }else{
            fullpage_api.setAutoScrolling(false);
            fullpage_api.setFitToSection(false);
        }
    })

    if($(this).width()>768){
        fullpage_api.setAutoScrolling(true);
        fullpage_api.setFitToSection(true);
    }else{
        fullpage_api.setAutoScrolling(false);
        fullpage_api.setFitToSection(false);
    }
})

function getRandom(min, max) {
    return Math.random() * (max - min) + min;
}

function newsSwiper(){

    new Swiper('.news_swiper', {
        loop: true,
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 15,
        autoplay: {
            speed: 1000,
        },
        breakpoints: {
            768: {
                spaceBetween: 20,
                slidesPerView: 2,
            },
            992: {
                spaceBetween: 30,
                slidesPerView: 3,
            },
        },
        navigation: {
            nextEl: '.swiper_btn_style_next',
            prevEl: '.swiper_btn_style_prev',
        },
    });
}

